import { trackClientEvent } from '../../../../trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'product_tile-brand_link-hover';

/**
 * Event fired when clicking the brand link on a product tile
 */
export function trackProductTileBrandLinkHover(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
